import { createSlice } from '@reduxjs/toolkit';
import { Reducers } from '@sda/enums/store';
import { extractSharedActions } from '@sda/utils/store';
import { createEntityAdapter } from '@client/store/entity.adapter';
import type { Payout } from '@sda/interfaces/payout';
import type { FetchDataType } from '@sda/sdk/interfaces';

export const payoutAdapter = createEntityAdapter<Payout & FetchDataType>();

const payoutsSlice = createSlice({
  initialState: payoutAdapter.getInitialState(),
  name: Reducers.PAYOUTS,
  reducers: {
    ...extractSharedActions(payoutAdapter),
    setPayouts: payoutAdapter.setAll,
  },
});

export const {
  setPayouts, updateOne: updatePayout,
} = payoutsSlice.actions;

export default payoutsSlice.reducer;
